import * as React from "react"
import { usePage } from "@inertiajs/react"
import {
  LifeBuoy,
  PanelLeftIcon,
  Send,
  Sparkles,
  Clock,
} from "lucide-react"
import { NavMain } from "@/components/nav/nav-main"
import { NavSecondary } from "@/components/nav/nav-secondary"
import { NavUser } from "@/components/nav/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import BlendIcon from "@assets/images/icons/blend.svg"


const data = {
  navSecondary: [
    {
      title: "Support",
      url: "#",
      icon: LifeBuoy,
    },
    {
      title: "Feedback",
      url: "#",
      icon: Send,
    },
  ],
}

export function AppSidebar({ ...props }) {
  const { current_workspace, current_user } = usePage().props
  const { state, toggleSidebar } = useSidebar()

  const { url } = usePage()

  const navMain = [
    {
      title: "Agents",
      url: `/${current_workspace?.slug}/agents`,
      icon: Sparkles,
      isActive: url.startsWith(`/${current_workspace?.slug}/agents`),
    },
    {
      title: "History",
      url: `/${current_workspace?.slug}/history`,
      icon: Clock,
      isActive: url.startsWith(`/${current_workspace?.slug}/history`),
    },
  ]

  return (
    <Sidebar collapsible="icon" variant="inset" {...props}>
      <SidebarHeader>
        <div className="flex items-center justify-between">
          <SidebarMenuButton
            asChild
            tooltip={state === "collapsed" ? "Open sidebar" : "Home"}
            size="lg"
            className="w-auto data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground group/logo gap-0"
          >
            <a
              href="/"
              className={state === "collapsed" ? "cursor-e-resize" : undefined}
              onClick={(e) => {
                if (state === "collapsed") {
                  e.preventDefault()
                  toggleSidebar()
                }
              }}
            >
              <div className="flex aspect-square size-8 items-center justify-center">
                <BlendIcon className="h-5 w-5 stroke-orange-500 group-data-[collapsible=icon]:group-hover/logo:hidden" />
                <PanelLeftIcon className="h-4 w-4 hidden group-data-[collapsible=icon]:group-hover/logo:block" />
              </div>
              <div className="truncate font-semibold text-lg pr-2 transition-opacity duration-300 ease-out group-data-[collapsible=icon]:opacity-0">DecodeKit</div>
            </a>
          </SidebarMenuButton>
          
          <Tooltip>
            <TooltipTrigger asChild>
              <SidebarTrigger className="cursor-w-resize group-data-[collapsible=icon]:hidden hover:bg-sidebar-accent hover:text-sidebar-accent-foreground text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </TooltipTrigger>
            <TooltipContent side="right">Close sidebar</TooltipContent>
          </Tooltip>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        {/*<NavSecondary items={data.navSecondary} className="mt-auto" />*/}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={current_user} />
      </SidebarFooter>
    </Sidebar>
  )
}
